<template>
	<div class="personSet_page">
		<div class="binding_content">
			<ul>
				<li v-for="(item,index) in binding" :key="index">
					<img :src="item.img">
					<p>{{item.tool}}</p>
					<button>解除绑定</button>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'binding',
	  data () {
	    return {
			binding:[
				{
					img:'https://static.wixstatic.com/media/a36401_379c8031c7a54ccaa4dbc498d85865b6~mv2_d_2961_2521_s_4_2.png/v1/fill/w_41,h_34,al_c,q_80,usm_0.66_1.00_0.01/wechat-logo-png-wechat-logo-icon-2961_pn.webp',
					tool:'微信'
				},
				{
					img:'https://static.wixstatic.com/media/a36401_a757d3ea806b45a1b608338bc667d099~mv2_d_2400_1942_s_2.png/v1/fill/w_43,h_34,al_c,q_80,usm_0.66_1.00_0.01/weibo-logo-transparent.webp',
					tool:'微博'
				},
				{
					img:'https://static.wixstatic.com/media/a36401_7da9361764944f20b161dd8236c138fb~mv2.png/v1/fill/w_40,h_40,al_c,q_80,usm_0.66_1.00_0.01/qq-logo.webp',
					tool:'QQ'
				}
			]
	    }
	  }
	}
</script>

<style scoped="scoped">
	.binding_content{
		width:500px;
		margin-left:100px;
		background-color: rgba(45,47,58,0.5);
		border-radius:20px;
	}
	.binding_content ul{
		position: relative;
		overflow: hidden;
		zoom: 1;
		padding:0 30px;
	}
	.binding_content ul li{
		width: 440px;
		height: 80px;
		line-height:80px;
		border-bottom: 1px rgba(199,199,199) solid;
	}
	.binding_content ul li:last-child{
		border-bottom: 0;
	}
	.binding_content ul li img{
		width: 40px;
		height: 40px;
		margin:20px 15px;
		position: absolute;
	}
	.binding_content ul li p{
		height: 80px;
		line-height:80px;
		margin-left: 100px;
		position: absolute;
		font-size:14px;
		color: #E8E6E6;
	}
	.binding_content ul li button{
		height: 20px;
		line-height: 16px;
		border:1px #fff solid;
		font-size:14px;
		color: #fff;
		float: right;
		right:20px;
		margin-top:30px;
		background-color: unset;
		border-radius:10px;
	}
	.binding_content ul li button:hover{
		color: #000;
		background-color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/personSet/binding.vue